import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/store";
import { getLoginCookieAndSession } from "../utils";
import { fetchUserByUniqueId, resetUserState } from "../redux/actions/userActions";

const useFetchUserDetails = () => {
  const dispatch = useDispatch();

  // Select the users state from Redux
  const { users, loading, error } = useSelector(
    (state: RootState) => state.users
  );

  useEffect(() => {
    const currentUserLoggedInProfileId = getLoginCookieAndSession();

    if (currentUserLoggedInProfileId) {
      dispatch(fetchUserByUniqueId(Number(currentUserLoggedInProfileId)));
    } else {
      dispatch(resetUserState());
    }
  }, [dispatch]);

  return { users, loading, error };
};

export default useFetchUserDetails;
